function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_172_5362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5 9H21.5V7.1C21.5 5.94 20.56 5 19.4 5H13.61C12.45 5 11.51 5.94 11.51 7.1V9H7.5C6.95 9 6.5 9.45 6.5 10C6.5 10.55 6.95 11 7.5 11H8.5V24C8.5 25.66 9.84 27 11.5 27H21.5C23.16 27 24.5 25.66 24.5 24V11H25.5C26.05 11 26.5 10.55 26.5 10C26.5 9.45 26.05 9 25.5 9ZM13.5 7.1L13.6 7H19.39L19.49 7.1V9H13.49V7.1H13.5ZM22.5 24C22.5 24.55 22.05 25 21.5 25H11.5C10.95 25 10.5 24.55 10.5 24V11H22.5V24ZM15.17 13.87V22.13C15.17 22.68 14.72 23.13 14.17 23.13C13.62 23.13 13.17 22.68 13.17 22.13V13.87C13.17 13.32 13.62 12.87 14.17 12.87C14.72 12.87 15.17 13.32 15.17 13.87ZM19.84 13.87V22.13C19.84 22.68 19.39 23.13 18.84 23.13C18.29 23.13 17.84 22.68 17.84 22.13V13.87C17.84 13.32 18.29 12.87 18.84 12.87C19.39 12.87 19.84 13.32 19.84 13.87Z",
    fill: "#097347",
    style: {
      fill: "#097347",
      fill: "color(display-p3 0.0353 0.4510 0.2784)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_172_5362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 22,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(6.5 5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.c7c08507619bfd641359ca5bd1631f32.svg";
export { ForwardRef as ReactComponent };